import { FC, useState } from "react";
import styles from './FileItem.module.less';
import { download } from "../../utils/download";
import DownloadIcon from "../DownloadList/DownloadIcon";

const AnnoItem: FC = (props) => {
    const [hover, setHover] = useState(false);
    return (
        <div style={{cursor: hover ? 'pointer' : '', backgroundColor: hover ? '#E7EFF7' : ''}} onClick={() => download(props.url, props.title)} onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)} className={styles.body}>
            <li style={{color: '#005BAC'}}></li>
            <div style={{fontWeight: hover ? 800 : 400}} className={styles.title}>{props.title}</div>
            <span style={{position: 'absolute', right: '0', fontSize: '12px', color: '#999999', marginRight: '160px', top: '1px'}}><DownloadIcon size={18} color={hover ? '#005BAC' : '#999999'} /></span>
            <div style={{fontWeight: hover ? 800 : 400}} className={`${styles.time} ${styles.right}`}>{props.time}</div>
            {/* <div className={`${styles.time} ${styles.last}`}>设备处发布</div> */}
        </div>
    );
}

export default AnnoItem;